// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2JzB3","box":"WorkspacesBox_box__1v21v","node":"WorkspacesBox_node__3SVEr"};